import { Directive } from '@angular/core';

/**
 * A cell of the filter row (`fr8botUiTableFilterRow`): 5px between neighbouring filters, 15px at
 * the table's left edge (level with the header and body cells) and 20px at its right edge,
 * whichever columns are visible and in whatever order — the same spacing in every table. Columns
 * without a filter keep an empty slot, so the edges are the first and last columns. Gray, with no
 * hover highlight, since the cell only holds a control.
 */
@Directive({
  selector: 'fr8bot-ui-table-header-cell[fr8botUiTableFilterCell]',
  host: {
    class: 'tw:w-full tw:bg-gray-7 tw:px-[5px] tw:hover:bg-gray-7 tw:first:pl-[15px] tw:last:pr-5',
  },
})
export class TableFilterCellUIDirective {}
